import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import ActionLogger from "action-logger";
import ProductCarousel from "../shared/carousels/product-carousel";
import { userDataPropType } from "components/propTypes";
import { pageTypes, analytics } from "rtr-constants";

class PDPCarousel extends React.Component {
  static propTypes = {
    annotationSuffix: PropTypes.string,
    closeModal: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    filters: PropTypes.object,
    isRentable: PropTypes.bool,
    isClearance: PropTypes.bool,
    loading: PropTypes.bool.isRequired,
    membershipPricing: PropTypes.array,
    product: PropTypes.shape({
      id: PropTypes.string,
    }),
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    shortlists: PropTypes.arrayOf(PropTypes.object),
    staticLogProperties: PropTypes.object,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    type: PropTypes.string,
    pixelName: PropTypes.string,
    url: PropTypes.string,
    userData: userDataPropType,
    noModelImageFirst: PropTypes.bool,
  };

  static defaultProps = {
    staticLogProperties: {
      object_type: "node",
      module_type: "pdp_carousel",
      pageType: pageTypes.PDP,
    },
  };

  componentDidMount() {
    const { label, pdp_style, all_products } = this.commonLogProperties();
    const { userData, products } = this.props;
    const userId = userData?.userProfile?.id;
    if (products?.length) {
      ActionLogger.logAction({
        object_type: analytics.OBJECT_TYPE.PDP_CAROUSEL,
        action: analytics.ACTION_TYPE.VIEW,
        user_id: userId,
        carousel: label,
        style_name: pdp_style,
        products: all_products,
      });
    }
  }

  commonLogProperties() {
    const { products = [], pixelName, staticLogProperties, product } = this.props;
    // changes display name to underscore separated string, e.g. 'You may also like' to 'you_may_also_like'
    const all_products = JSON.stringify(products.map(product => product?.id));
    return {
      ...staticLogProperties,
      label: pixelName,
      pdp_style: product?.id,
      all_products,
    };
  }

  extraPixelData() {
    return {
      action: "click_item",
      nthStyleRequired: true,
      ...this.commonLogProperties(),
    };
  }

  logStylesInView = (styleNames, carousel, index, previousIndex, newIndex) => {
    const movingRight = newIndex - previousIndex > 0;
    const dataToLog = {
      action: "visible_products",
      products: JSON.stringify(styleNames),
      ...this.commonLogProperties(),
    };

    if (movingRight) {
      ActionLogger.logAction(dataToLog);
    }
  };

  viewAll = () => {
    ActionLogger.inferAction({
      action: "click_view_all",
      ...this.commonLogProperties(),
    });
  };

  carouselLink = () => {
    if (this.props.url && this.props.subtitle) {
      return (
        <p className="carousel-subtitle">
          <a className="universal-small--semibold universal-underline" href={this.props.url} onClick={this.viewAll}>
            {this.props.subtitle}
          </a>
        </p>
      );
    }
  };

  render() {
    if ((!this.props.isRentable && !this.props.isClearance) || _.isEmpty(this.props.products)) {
      return null;
    }

    return (
      <div className={`pdp-carousel carousel-with-title ${this.props.type.toLowerCase()}-carousel`}>
        <div className="pdp-carousel-header">
          <h2 className="h3 carousel-header">{this.props.title}</h2>
          {this.carouselLink()}
        </div>
        <div className="pdp-carousel__products">
          <ProductCarousel
            annotationSuffix={this.props.annotationSuffix}
            closeModal={this.props.closeModal}
            customHeartLoggingOptions={this.commonLogProperties()}
            dispatch={this.props.dispatch}
            extraPixelData={this.extraPixelData()}
            filters={this.props.filters}
            isPdpCarousel={true}
            isRentable={this.props.isRentable}
            isFullBleedCarousel={true}
            isPeekCarousel={true}
            loading={this.props.loading}
            logStylesInView={this.logStylesInView}
            membershipPricing={this.props.membershipPricing}
            products={this.props.products}
            shortlists={this.props.shortlists}
            type={this.props.type}
            userData={this.props.userData}
            noModelImageFirst={this.props.noModelImageFirst}
            isClearance={this.props.isClearance}
            title={this.props.title}
          />
        </div>
      </div>
    );
  }
}

export default PDPCarousel;
